// Production configuration
// For deploying to production server

module.exports = {
  // Production API URL - points to production backend
  // The /api prefix will be handled by nginx proxy
  apiUrl: 'https://test.datacopro.com/api',
  imagePublicBaseUrl: 'https://test.datacopro.com',
};

